var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactFormImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.974 -23.4746C258.307 24.312 244.159 87.6408 196.372 117.974C148.585 148.307 85.2567 134.159 54.9233 86.3721C24.59 38.5854 38.7387 -24.7433 86.5254 -55.0767C134.312 -85.41 197.641 -71.2613 227.974 -23.4746ZM82.6286 68.7857C103.249 101.271 146.3 110.889 178.786 90.2688C211.271 69.6482 220.889 26.5972 200.269 -5.88824C179.648 -38.3737 136.597 -47.992 104.112 -27.3714C71.6263 -6.75072 62.008 36.3003 82.6286 68.7857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.985 24.1258C157.03 30.4974 155.143 38.9412 148.772 42.9857C142.4 47.0301 133.956 45.1436 129.912 38.7721C125.868 32.4005 127.754 23.9567 134.126 19.9122C140.497 15.8678 148.941 17.7543 152.985 24.1258Z",
    fill: "#A1C6E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.488 -21.3806C100.831 -14.1884 91.1567 -3.1345 86.0542 9.96685C80.9517 23.0682 80.7238 37.4386 85.4078 50.7193C90.0919 64 99.4097 75.402 111.832 83.0538C124.254 90.7057 139.042 94.1527 153.77 92.8292L157.259 91.6999C143.949 92.896 126.472 85.0049 115.246 78.0894C104.019 71.174 95.5982 60.8694 91.3649 48.8668C87.1317 36.8643 87.3377 23.877 91.9491 12.0365C96.5605 0.196055 105.661 -16.934 117.1 -23.434L113.488 -21.3806Z",
    fill: "#A1C6E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactFormImage);
export default __webpack_public_path__ + "static/media/contact-form-image.85a5db0d4e69df470e36444b270cc9d9.svg";
export { ForwardRef as ReactComponent };